import React from 'react'
import { Link, useParams } from 'react-router-dom'

import Slider from "react-slick";

import bg1 from '../../assets/img/p-1.jpg'
import bg2 from '../../assets/img/p-2.jpg'
import bg3 from '../../assets/img/p-3.jpg'
import bg4 from '../../assets/img/p-4.jpg'
import bed from '../../assets/img/bed.svg'
import bathtub from '../../assets/img/bathtub.svg'
import move from '../../assets/img/move.svg'

import Navbar from '../../components/navbar/navbar'
import PropertyDetail from '../../components/property-detail';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';
import DetailSidebarTwo from '../../components/detail-sidebar-two';
import SEO from '../../components/SEO';
import ExchangeRateDisclosure from '../../components/ExchangeRateDisclosure';

import { propertyData } from '../../data/data';

var settings = {
    dots: false,
    slidesToShow: 2,
    infinite: true,
    autoplay:true,
    autoplaySpeed: 2000,
    speed: 3000,
    slidesToScroll: 1,
    centerMode: true,
  };

export default function SinglePropertyFour() {
    let params = useParams()
    let id:any = params.id
    let data = propertyData.find((item:any)=>item.id === parseInt(id))

    // SEO dinámico basado en la propiedad
    const propertyName = data?.name || 'Propiedad en Venta';
    const propertyPrice = data?.value || '$7,600';
    const propertyLocation = data?.loction || 'Riviera Nayarit';
    const propertyImage = Array.isArray(data?.image) ? data?.image[0] : data?.image || 'https://ampirivieranayarit.com/wp-content/uploads/2025/03/mob-slide-1.jpg';

    // Schema.org para RealEstateListing
    const propertySchema = {
      "@context": "https://schema.org",
      "@type": "RealEstateListing",
      "name": propertyName,
      "description": `${propertyName} - Propiedad disponible en ${propertyLocation}`,
      "url": `https://ampirivieranayarit.com/modulob/single-property-4/${id || ''}`,
      "image": propertyImage,
      "price": propertyPrice,
      "priceCurrency": "MXN",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": propertyLocation,
        "addressCountry": "MX"
      },
      "offers": {
        "@type": "Offer",
        "price": propertyPrice,
        "priceCurrency": "MXN",
        "availability": "https://schema.org/InStock"
      }
    };

  return (
    <>
        <SEO
          title={propertyName}
          description={`${propertyName} en venta en ${propertyLocation}. Encuentra esta y más propiedades exclusivas verificadas por AMPI Riviera Nayarit.`}
          path={`/modulob/single-property-4/${id || ''}`}
          image={propertyImage}
          type="article"
          schema={propertySchema}
        />
        <Navbar transparent={false}/>   

        <div className="featured_slick_gallery gray">
            <div className="featured_slick_gallery-slide home-slider">
                <Slider {...settings}>
                    <div className="featured_slick_padd"><a href="assets/img/p-1.jpg" className="mfp-gallery"><img src={bg1} className="img-fluid mx-auto" alt="" /></a></div>
                    <div className="featured_slick_padd"><a href="assets/img/p-2.jpg" className="mfp-gallery"><img src={bg2} className="img-fluid mx-auto" alt="" /></a></div>
                    <div className="featured_slick_padd"><a href="assets/img/p-3.jpg" className="mfp-gallery"><img src={bg3} className="img-fluid mx-auto" alt="" /></a></div>
                    <div className="featured_slick_padd"><a href="assets/img/p-4.jpg" className="mfp-gallery"><img src={bg4} className="img-fluid mx-auto" alt="" /></a></div>
                </Slider>
            </div>
            <Link to="#" className="btn-view-pic">View photos</Link>
        </div>

        <section className="gray-simple">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-sm-12">
                        <div className="property_block_wrap style-2 p-4">
                            <div className="prt-detail-title-desc">
                                <span className="label text-light bg-success">For Sale</span>
                                <h3 className='mt-3'>{data?.name ? data?.name : 'Jannat Graynight Mood In Siver Colony, London'}</h3>
                                <span><i className="lni-map-marker"></i> 778 Country St. Panama City, FL</span>
                                <h3 className="prt-price-fix text-primary mt-2">$7,600<sub>/month</sub></h3>

                                {/* Disclaimer de tipo de cambio */}
                                <div className="alert alert-warning mt-3 mb-3" role="alert">
                                    <div className="d-flex align-items-start">
                                        <i className="fa-solid fa-exclamation-triangle me-2 mt-1"></i>
                                        <div>
                                            <strong>Nota importante sobre tipo de cambio:</strong>
                                            <p className="mb-2 mt-1">El tipo de cambio mostrado es referencial. Cada agencia inmobiliaria maneja su propio tipo de cambio según sus políticas comerciales.</p>
                                            <ExchangeRateDisclosure variant="badge" className="mb-2" />
                                            <p className="mb-0 small">Por favor confirma el precio final directamente con la agencia o asesor responsable de esta propiedad.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="list-fx-features">
                                    <div className="listing-card-info-icon">
                                        <div className="inc-fleat-icon me-1"><img src={bed} width="13" alt=""/></div>3 Beds
                                    </div>
                                    <div className="listing-card-info-icon">
                                        <div className="inc-fleat-icon me-1"><img src={bathtub} width="13" alt=""/></div>1 Bath
                                    </div>
                                    <div className="listing-card-info-icon">
                                        <div className="inc-fleat-icon me-1"><img src={move} width="13" alt=""/></div>800 sqft
                                    </div>
                                </div>
                            </div>
                        </div>
                        <PropertyDetail/>
                    </div>
                    
                    <div className="col-lg-4 col-md-12 col-sm-12">
                        <DetailSidebarTwo/>
                    </div>
                </div>
            </div>
        </section>
        <FooterTop bg="theme-bg"/>
        <Footer/>
    </>
  )
}
